import { MetaHeader } from "~/components/MetaHeader";
import { DefaultLayout } from "~/layouts/DefaultLayout";
import { MetaHeader } from "~/components/MetaHeader";
import { ArticlePage } from "~/components/ArticlePage";
import { LoaderFunction, useLoaderData } from 'remix';
import { SupabaseClientFn } from '~/utils/db.server';
import type { MetaFunction } from "remix";

export const loader: LoaderFunction = async ({ request }) => {
    const url = new URL(request.url);

    // URLSearchParamsを使用してクエリパラメータを取得
    const articleId = url.searchParams.get('article_id');
    // Supabaseを使用してデータを取得
    const { data, error } = await SupabaseClientFn
        .from('articles').select().eq('article_name', articleId);

    if (error) {
        console.error("Error fetching shops:", error);
        return new Response(JSON.stringify({ message: "Error fetching data" }), {
            status: 500,
            headers: {
                "Content-Type": "application/json",
            },
        });
    }
    const shopIds = data[0].store_ids;

    const day = new Date().getDay();
    const shopsDetailRes = await SupabaseClientFn
        .from('shops')
        .select(`
        *,
        shop_images!left(images!inner(image_url,photographer_icon,photographer_name)),
        shop_business_days!left(day_id,business_hours_start,business_hours_end,is_closed),
        embeds!left(embed_name,embed_id)
    `)
        .in('shop_id', shopIds)
        .order('shop_id', { ascending: false }); 
    data.push(shopsDetailRes.data);

    const returnData = {
        article: data[0],
        shops: data[1],
    }


    // データをJSONとして返す
    return returnData
};

const Cafe: React.VFC = () => {
    const data = useLoaderData<HashtagShopsData>();
    return (
        <>
            <MetaHeader title={data.article.article_title + ' - 福岡カフェ日記 | 福岡最大級のカフェメディア'} description={data.article.article_description} />
            <DefaultLayout>
                <ArticlePage articleData={data} />
            </DefaultLayout>
        </>
    );
};

export default Cafe;
